module.exports = __webpack_public_path__ + "static/img/course-default.d8cf269c.png";